import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../containers/FrontPage/Pages/Home";
import HowToStart from "../containers/FrontPage/containers/HowToStart/HowtoStart";
import AboutPage from "../containers/FrontPage/containers/About/AboutPage";
// import Contact from "../containers/FrontPage/containers/Contact";
import ComingSoon from "../containers/FrontPage/Pages/comingsoon/ComingSoon";
import Home2 from "../containers/FrontPage/Pages/Home2";
import Contact2 from "../containers/FrontPage/components/Contact2/Contact";

const FrontPage = () => {
  return (
    <>
      <Routes>
        <Route path="/" index element={<Home2 />} />
        {/* <Route path="/" index element={<ComingSoon />} /> */}
        <Route path="/how-to-start" element={<HowToStart />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<Contact2 />} />
      </Routes>
    </>
  );
};

export default FrontPage;
